<app-select2 *ngIf="!palette"
  cmpCssClasses="qa-add-question mb-3"
  btnCssClasses="btn-success add-btn"
  label="{{_(KEYS.EDITOR.ADD_ELEMENT)}}"
  buttonFaIcon="fa-plus"
  (cmpElement)="cmpEl = $event"
  (submit)="onAddElement($event)"
  [options]="options"
  [hideLabel]="hideLabel"
>
  <option value="">...</option>
  <optgroup *ngFor="let group of elementGroups" label="{{group.title}}">
    <option *ngFor="let element of group.elements" value="{{element.value}}">
      {{element.title}}
    </option>
  </optgroup>
</app-select2>

<aside *ngIf="palette" class="qa-element-palette" [attr.aria-label]="_(KEYS.EDITOR.ADD_ELEMENT)">
  <h3>{{_(KEYS.EDITOR.ADD_ELEMENT)}}</h3>
  <section *ngFor="let group of elementGroups" [dragula]="'palette-bag'">
    <h4>{{group.title}}</h4>
    <button *ngFor="let element of group.elements" type="button" class="qa-palette-item"
            [attr.data-question-template]="element.value" (click)="onAddElement(element.value)">
      <span class="palette-icon"><i class="fa {{iconMapping[element.value] || 'fa-plus'}}" aria-hidden="true"></i></span>
      <span class="palette-label">{{element.title}}</span>
      <i class="fa fa-plus palette-add" aria-hidden="true"></i>
    </button>
  </section>
</aside>
